import billingDashboard from "./billingDashboard";
import developers from "./developers";
import roadcubeMarket from "./roadcubeMarket";

export default {
    namespaced: true,

    modules: {
        billingDashboard,
        developers,
        roadcubeMarket
    },
};
